enum donationType {
  Online = 'online',
  Offline = 'offline',
  Pledge = 'pledge',
  Pending = 'pending'
}

export default donationType;
